import { ready } from '../global/instantiate';
import bambuserify from '../global/bambuser'
import handleBIS from './../sections/product/handleBIS';
import { productInit } from '../sections/product';

ready(() => {

  productInit({}, (variant, productData) => {
    if (variant && productData) {
      handleBIS(variant, productData);
    }
  });
  bambuserify();
});
